import { forwardRef } from 'react';

import type { IconProps } from './types';

export const Gallerry = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0192 6.69041C19.1085 6.83345 19.8445 7.16759 20.3402 7.6633C21.0164 8.33944 21.3919 9.4627 21.3919 11.3197V15.9373C21.3919 17.7943 21.0164 18.9175 20.3402 19.5937C19.6641 20.2698 18.5408 20.6454 16.6838 20.6454H12.0663C10.2093 20.6454 9.086 20.2698 8.40986 19.5937C8.16003 19.3439 7.95123 19.033 7.78726 18.6466L6.40125 18.8224C6.6327 19.4984 6.97398 20.0785 7.44953 20.554C8.50498 21.6095 10.0753 22.0035 12.0663 22.0035H16.6838C18.6748 22.0035 20.2451 21.6095 21.3006 20.554C22.356 19.4986 22.75 17.9282 22.75 15.9373V11.3197C22.75 9.32875 22.356 7.75842 21.3006 6.70297C20.4161 5.81849 19.17 5.3985 17.6178 5.28564L18.0192 6.69041Z"
      fill={color}
    />
    <path
      d="M4.733 18.8022L4.72026 18.8225C4.38383 18.3855 4.11493 17.8631 3.91546 17.2636C4.11301 17.8548 4.39657 18.3651 4.733 18.8022Z"
      fill={color}
    />
    <path
      d="M8.40082 10.4269C8.9236 10.3062 9.37703 9.98277 9.66135 9.52777C9.94567 9.07276 10.0376 8.52345 9.9169 8.00066C9.7962 7.47788 9.47278 7.02446 9.01777 6.74014C8.56277 6.45582 8.01345 6.3639 7.49067 6.48459C6.96789 6.60528 6.51446 6.92871 6.23014 7.38371C5.94582 7.83872 5.8539 8.38803 5.9746 8.91082C6.09529 9.4336 6.41871 9.88702 6.87372 10.1713C7.32872 10.4557 7.87804 10.5476 8.40082 10.4269Z"
      fill={color}
    />
    <path
      d="M12.7524 2.11105L5.81193 3.71337C2.79723 4.40937 1.41492 6.62152 2.11092 9.63622L3.71325 16.5767C3.92167 17.4794 4.26086 18.2307 4.72026 18.8225C5.79582 20.2317 7.52415 20.7652 9.6361 20.2777L16.5765 18.6753C19.5912 17.9793 20.9735 15.7672 20.2775 12.7525L18.6752 5.81205C17.9792 2.79735 15.7671 1.41505 12.7524 2.11105ZM18.222 10.008C17.4479 9.60229 16.4043 9.84321 15.8864 10.5473L13.1237 14.2994C12.6058 15.0035 11.5622 15.2444 10.7881 14.8386L10.453 14.6717C9.74639 14.294 8.79904 14.4604 8.23972 15.0606L5.62213 17.8545C5.33284 17.4328 5.10089 16.9193 4.95557 16.2898L3.35325 9.34941C2.81404 7.01384 3.76318 5.4949 6.09874 4.95569L13.0392 3.35337C15.3747 2.81416 16.8937 3.7633 17.4329 6.09886L18.3507 10.0743L18.222 10.008Z"
      fill={color}
    />
  </svg>
));

export default Gallerry;
